import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import PagesHeroSection from '../../components/pagesHeroSection/pagesHeroSection';
import SEOUpdater from '../../utils/hoc/SEOUpdater';
import './accessibilityPage.scss';

const AccessibilityPage = () => {
  const { t } = useTranslation('accPage');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="accessibilityPage">
      {/* Dynamic SEO metadata */}
      <SEOUpdater page="accPage" />

      {/* Hero section */}
      <PagesHeroSection page={t('heroTitle')} />

      {/* Main content */}
      <div className="container mt-4">
        {/* Keyboard Navigation */}
        <h4 className="fw-bold">{t('keyboardTitle')}</h4>
        <p>{t('keyboardParagraph')}</p>

        {/* Access Keys Table */}
        <table className="table">
          <caption>{t('accessKeysTitle')}</caption>
          <thead className="thead-dark">
            <tr>
              <th scope="col">{t('accessKey')}</th>
              <th scope="col">{t('description')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>{t('access1')}</td>
            </tr>
            <tr>
              <td>2</td>
              <td>{t('access2')}</td>
            </tr>
            <tr>
              <td>3</td>
              <td>{t('access3')}</td>
            </tr>
            <tr>
              <td>9</td>
              <td>{t('access9')}</td>
            </tr>
            <tr>
              <td>0</td>
              <td>{t('access0')}</td>
            </tr>
          </tbody>
        </table>

        {/* Standards */}
        <h4 className="fw-bold">{t('standardsTitle')}</h4>
        <p>{t('standards1')}</p>
        <p>{t('standards2')}</p>
        <p>{t('standards3')}</p>

        {/* Navigation */}
        <h4 className="fw-bold mt-4">{t('navTitle')}</h4>
        <p>{t('nav1')}</p>
        <p>{t('nav2')}</p>

        {/* Links */}
        <h4 className="fw-bold mt-4">{t('linksTitle')}</h4>
        <p>{t('links1')}</p>
        <p>{t('links2')}</p>

        {/* Images */}
        <h4 className="fw-bold mt-4">{t('imagesTitle')}</h4>
        <p>{t('images1')}</p>

        {/* Design */}
        <h4 className="fw-bold mt-4">{t('designTitle')}</h4>
        <p>{t('design1')}</p>
        <p>{t('design2')}</p>
      </div>
    </div>
  );
};

export default AccessibilityPage;
